import { websiteCtaUrl } from "../lib/pageSafety";

export default function WebsiteCta({ href, children, style }) {
  const destination = websiteCtaUrl(href);
  if (!destination) return <button type="button" disabled title="Link not configured" style={{ ...style, opacity: 0.6, cursor: "not-allowed" }}>{children}</button>;
  return <a href={destination} style={{ ...style, display: "inline-flex", textDecoration: "none" }}>{children}</a>;
}
